import React from "react";
import AutonomousContainer from "components/Player/layout/AutonomousContainer"
import ImageContainer from "components/Player/layout/ImageContainer"
import ControlContainer from "components/Player/layout/ControlContainer"
import InterludeController from 'components/Player/layout/interlude/InterludeController'
import { translate } from "utlis/translations/i18n";
class PlayerInterlude extends React.Component {
  render() {
    const {
      session,
      current,
      interludes = [],
      instance,
      onNextInterlude,
      onPrevInterlude,
      onFinishInterlude
    } = this.props;
    const { metadata } = session;
    const { type } = metadata;

    if (current >= interludes.length || current < 0)
      return (
        <p>{translate('player.interludeCouldNotBeDisplayed')}</p>
      );
    if (type === "PILOTED")
      return (
        <PilotedLayout
          session={session}
          interludes={interludes}
          instance={instance}
          currentInterlude={current}
        />
      );
    if (type === "AUTONOMOUS")
      return (
        <AutonomousLayout
          session={session}
          interludes={interludes}
          instance={instance}
          onNextInterlude={onNextInterlude}
          onPrevInterlude={onPrevInterlude}
          onFinishInterlude={onFinishInterlude}
        />
      );
    return <div>Unknown session type</div>;
  }
}

class PilotedLayout extends React.Component {
  render() {
    const { interludes, currentInterlude } = this.props;
    const interludeToShow = interludes[currentInterlude];

    if (!interludeToShow) {
      return <></>
    }
    return (
      <div className="interlude-wrapper">
        {(!interludeToShow.type ||
          interludeToShow.type === "IMAGE") && (
            <img
              src={interludeToShow.downloadURL}
              className="img-interlude"
              alt="Resource"
            />
          )}
        {interludeToShow.type === "VIDEO" && (
          <video
            src={interludeToShow.downloadURL}
            className="img-responsive"
            alt="Resource"
            controls={true}
          />
        )}
      </div>
    );
  }
}

class AutonomousLayout extends React.Component {
  isFirstInterlude = () => this.props.instance.currentInterlude === 0;
  isLastInterlude = () =>
    this.props.instance.currentInterlude ===
    this.props.session.data.interludes.length - 1;

  render() {
    const {
      session,
      interludes,
      instance,
      onPrevInterlude,
      onNextInterlude,
      onFinishInterlude
    } = this.props;
    const { currentInterlude } = instance;
    const interludeToShow = interludes[currentInterlude];

    return (
      <AutonomousContainer>
        <ImageContainer>
          {(!interludeToShow.type ||
            interludeToShow.type === "IMAGE") /** Use constants */ && (
              <img
                src={interludeToShow.downloadURL}
                className="img-responsive"
                alt="Resource"
              />
            )}
          {interludeToShow.type === "VIDEO" /** Use constants */ && (
            <video
              src={interludeToShow.downloadURL}
              className="img-responsive"
              alt="Resource"
              controls={true}
            />
          )}
        </ImageContainer>
        <ControlContainer>
          <InterludeController
            isFirstInterlude={this.isFirstInterlude}
            isLastInterlude={this.isLastInterlude}
            session={session}
            instance={instance}
            onNextInterlude={onNextInterlude}
            onPrevInterlude={onPrevInterlude}
            onFinishInterlude={onFinishInterlude}
          />
        </ControlContainer>
      </AutonomousContainer>
    );
  }
}

export default PlayerInterlude;
